module.exports = __webpack_public_path__ + "public/media/developer.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer.png
// module id = ./images/services/developer.png
// module chunks = 0